import { ContentAggregatorSchemeDefinition } from "./content-aggregator-types";
import { BackgroundColor } from "../../background/constants/background-types";

import * as AllColors from "../../../constants/colors";
import { createContentAggregatorMapDefinition } from "../../../utils/scheme-helper";
import { toConstantCase } from "../../../utils/string-format";

export const THREE_ITEMS = 3;
export const TWO_ITEMS = 2;

export const SIX_ITEMS = 6;
export const TWELVE_ITEMS = 12;
export const EIGHT_ITEMS = 8;
export const FOUR_ITEMS = 4;

export const CONTENT_AGGREGATOR_LARGE_GRID_SIZE = "large";
export const CONTENT_AGGREGATOR_SMALL_GRID_SIZE = "small";

export const CONTENT_AGGREGATOR_GRID_SIZE = [
  CONTENT_AGGREGATOR_LARGE_GRID_SIZE,
  CONTENT_AGGREGATOR_SMALL_GRID_SIZE
] as const;

export const NUMBER_OF_ITEMS_PER_CAROUSEL_WINDOW = [THREE_ITEMS, TWO_ITEMS] as const;

export const CONTENT_AGGREGATOR_LAYOUT_LIST = "list";
export const CONTENT_AGGREGATOR_LAYOUT_LIST_EXPANDED = "list_expanded";
export const CONTENT_AGGREGATOR_LAYOUT_CAROUSEL = "carousel";
export const CONTENT_AGGREGATOR_LAYOUT_TILE = "tile";

export const CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENT_LEFT = "left";
export const CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENT_RIGHT = "right";
export const CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENT_ALTERNATE = "alternate";

export const CONTENT_AGGREGATOR_LAYOUTS = [
  CONTENT_AGGREGATOR_LAYOUT_LIST,
  CONTENT_AGGREGATOR_LAYOUT_LIST_EXPANDED,
  CONTENT_AGGREGATOR_LAYOUT_CAROUSEL,
  CONTENT_AGGREGATOR_LAYOUT_TILE
] as const;

export const CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENTS = [
  CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENT_LEFT,
  CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENT_RIGHT,
  CONTENT_AGGREGATOR_ITEM_LAYOUT_ALIGNMENT_ALTERNATE
] as const;

function createSchemes() {
  let newSchemes: AllColors.ContentAggregatorSchemeConfiguration<ContentAggregatorSchemeDefinition> = {};
  AllColors.CONTENT_AGGREGATOR_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      color: AllColors[`COLOR_${toConstantCase(element.schemeName)}`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const CONTENT_AGGREGATOR_SCHEME_CONFIG: AllColors.ContentAggregatorSchemeConfiguration<ContentAggregatorSchemeDefinition> = createSchemes();

export const CONTENT_AGGREGATOR_SCHEME_MAP: Map<
  BackgroundColor | "default",
  ContentAggregatorSchemeDefinition
> = new Map(
  Object.entries(createContentAggregatorMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    CONTENT_AGGREGATOR_SCHEME_CONFIG[config as string]
  ])
);
